import React from 'react';
import { useTranslation } from 'react-i18next';

import EnergyRevenueOverlayChart from '../station-comparison/EnergyRevenueOverlayChart';
// import SessionCountPerStationChart from '../station-comparison/SessionCountPerStationChart';
import StationComparisonList from '../station-comparison/StationComparisonList';
import UptimeTrendOverTimeChart from '../station-comparison/UptimeTrendOverTimeChart';

/**
 * Station Comparison
 * @returns {JSX.Element} The Station Comparison component.
 */
function StationComparison() {
  const { t } = useTranslation('stationManagement');
  return (
    <div className="station-comparison-main">
      <StationComparisonList />
      <p className='graph-view'>{t('graphView')}</p>
      <div className="station-comparison-chart">
        <EnergyRevenueOverlayChart />
        {/* <SessionCountPerStationChart /> */}
        <UptimeTrendOverTimeChart />
      </div>
    </div>
  );
}

export default StationComparison;
